module.exports = __webpack_public_path__ + "img/retro-respect.cccd02bb.jpg";